'use client';

import { useEffect, useState } from 'react';
import { Box, useMediaQuery } from '@mui/material';

const AdSenseAd = ({
  adSlot,
  layoutKey = '',
  fullWidth = false,
  format = 'auto',
  mobile,
  style = {},
  sx = {},
}) => {
  const [isClient, setIsClient] = useState(false);
  const [isAdBlocked, setIsAdBlocked] = useState(false);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));
  useEffect(() => {
    setIsClient(true);
  }, []);
  useEffect(() => {
    if (
      window &&
      !(!isClient || (mobile && !isMobile) || (!mobile && isMobile))
    ) {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }

    // Check if ads are blocked
    if (window) {
      let testAd = document.createElement('div');
      testAd.innerHTML = '&nbsp;';
      testAd.className = 'adsbygoogle';
      testAd.style.position = 'absolute';
      testAd.style.fontSize = '10px';
      testAd.style.top = '-1000px';
      document.body.appendChild(testAd);

      window.setTimeout(function () {
        if (testAd.offsetHeight === 0) {
          setIsAdBlocked(true);
        }
        testAd.remove();
      }, 1000);
    }
  }, [isClient]);

  if (
    !isClient ||
    (mobile && !isMobile) ||
    (!mobile && isMobile) ||
    isAdBlocked
  ) {
    return;
  }

  return (
    <Box sx={{ ...sx }}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block', textAlign: 'center', ...style }}
        data-ad-client="ca-pub-3043658465039401"
        data-ad-slot={adSlot}
        data-ad-layout-key={layoutKey}
        data-ad-format={format}
        data-full-width-responsive={mobile || fullWidth}
      />
    </Box>
  );
};

export default AdSenseAd;
